<!--
 * @Author: 吴作杰 15727841808@163.com
 * @Date: 2024-01-11 14:38:01
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2024-03-04 18:05:44
 * @FilePath: /chaoyongtuan/src/views/shopManage/components/extensionDrawer.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<el-drawer custom-class="drawer-extension" :append-to-body="true" :visible.sync="visible" :size="1200" @close="handleClose">
		<template #title>
			<div>
				<div class="title">批量延长推广</div>
				<div class="mt-2 fz-14 yx-color-text-secondary">注意：拒绝发货后将不可撤销，请确认后再操作</div>
			</div>
		</template>
		<div class="drawer-content">
			<Tip :type="'warning'">
				延长推广时间的申请需合作方审核，通过后立即生效，3天未处理则视为拒绝
			</Tip>
			<div class="setting-content mt-16">
				<div class="setting-title fz-16"> 延长推广设置 </div>
				<div class="setting-select fz-14 mt-24"> 您已选择<span class="num">{{ total }}</span>个商品，其中<span class="num">{{ valid_total }}</span>个符合延长推广要求 </div>
				<div class="extension-time mt-24">
					<div class="label fz-14">一键设置延长时间</div>
					<div class="extension-content">
						<el-radio v-model="openType" label="1" @change="selectTime = ''">是</el-radio>
						<el-radio v-model="openType" label="2"  @change="selectTime = ''">否</el-radio>
					</div>
				</div>
				<div class="select-prolong mt-24" v-if="+openType === 1">
					<div class="label fz-14">选择延长时间</div>
					<div class="select-content">
						<el-select v-model="selectTime" placeholder="请选择" @change="onSelect">
							<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value" :disabled="item.disabled"> </el-option>
						</el-select>
					</div>
				</div>
				<multi-table class="gray-table-header mt-16" ref="table" :showPager="false" :columns="columns" :list="list" :total="total">
					<empty ref="empty" slot="empty"></empty>
				</multi-table>
			</div>
		</div>
		<div class="bottom-sumbit">
			<el-button @click="visible = false">取消</el-button>
			<el-button class="mr-16" type="primary" @click="submit" :disabled="!disabled">提交申请</el-button>
		</div>
	</el-drawer>
</template>
<script>
import { addMonths, format } from 'date-fns';
import { batchDelayPreviewList, recordsBatchCreate } from '@/api/shopManage';
import empty from '@/views/common/empty/index.vue';
import debounce from 'lodash/debounce';
import getColumns from './columns';
export default {
	data() {
		return {
			visible: false,
			openType: '1',
			options: [
				{ label: '1个月', value: 1 },
				{ label: '2个月', value: 2 },
				{ label: '3个月', value: 3 },
				{ label: '6个月', value: 6 },
				{ label: '12个月', value: 12 },
			],
			selectTime: '',
			total: 0,
			columns: getColumns(),
			list: [],
			product_ids:[],
			valid_total: 0,
		};
	},
	components: {
		
		empty,
	},
	computed: {
		disabled() {
			let newList = this.list.filter(val => val.enable);
			let filList = [];
			newList.map(val => {
				if (val.delay_date) {
					filList.push(val.delay_date);
				}
			});
			return filList.length === newList.length;
		},
	},
	methods: {
		handleClose() {
			this.selectTime = '';
			this.openType = '1';
			this.visible = false;
			this.list = [];  
		},
		show(productArr){
			this.visible = true;
			this.product_ids = productArr.map(val => val.product_id);
			this.getList();
		},
		async getList() {
			const { product_ids } = this
			const { code, data } = await batchDelayPreviewList({product_ids});
			if( code !== 0 ) return; 
			data.list.map(val => {
				val.delay_date = '';
			});
			this.list = data.list;
			this.total = data.total;
			this.valid_total = data.valid_total;
		},
		onSelect(v) {
			this.list.map(val => {
				if (val.enable) {
					val.delay_date = format(addMonths(new Date(), v), 'yyyy-MM-dd');
				}
			});
		},
		submit: debounce(async function () {
			let params = [];
			this.$refs.table.list.map((val)=>{
				if(val.enable){
					params.push({
						product_id: val.product_id,
						delay_date: val.delay_date
					})
				}
			})
			const { code } = await recordsBatchCreate({params});
			if( code === 0 ){
				this.$message.success('操作成功');
				this.visible =  false;
				this.$emit('refreshList')
			}
		},500)
	},
};
</script>
<style lang="less" scoped>
/deep/ .el-drawer__body {
	padding: 16px !important;
	background-color: #f7f8f9;
}

/deep/ .el-table__header-wrapper {
	position: sticky !important;
	top: -20px !important;
	z-index: 10;
}
.drawer-extension {
	.title {
		color: @color-gy9;
		font-size: 16px;
		font-weight: 500;
	}
	.setting-content {
		padding: 16px;
		border-radius: 8px;
		background: #ffff;
	}
	.setting-title {
		position: relative;
		color: @color-gy9;
		padding-left: 8px;
		font-weight: 500;
	}
	.setting-title::before {
		content: '';
		position: absolute;
		width: 3px;
		height: 17px;
		border-radius: 20px;
		background: @color-b4;
		left: 0px;
		top: 50%;
		transform: translateY(-50%);
	}
	.setting-select {
		color: @color-gy11;
	}
	.num {
		color: @color-b4;
	}
	.extension-time {
		display: flex;
		align-items: center;
		.label {
			margin-right: 12px;
			min-width: 120px;
			color: @color-text-primary;
		}
		/deep/ .el-radio {
			margin-top: 3px;
		}
	}
	.select-prolong {
		display: flex;
		align-items: center;
		.label {
			margin-right: 12px;
			min-width: 120px;
			color: @color-text-primary;
		}
	}
	.drawer-content {
		margin-bottom: 100px;
	}
	.bottom-sumbit {
		box-shadow: 0px -2px 10px 0px rgba(0, 0, 0, 0.04);
		position: absolute;
		display: flex;
		align-items: center;
		justify-content: end;
		width: 100%;
		left: 0px;
		height: 60px;
		bottom: 0px;
		background: @color-gy1;
	}
}
</style>
